import { getLeftNavGroupFoldersStore } from '../store/store';
import { getGroupFolderId } from './getGroupFolderId';
import { GroupFolderWellKnownName } from 'owa-folders-constants';

/**
 * @param groupId Smtp address of the group
 * @param folderId Folder Id of the group folder
 * @returns Child folders of a Group / Group folder.
 */
export function getGroupFolderChildFolderIds(
    groupId: string,
    folderId?: string
): string[] | undefined {
    groupId = groupId.toLowerCase();
    const folderHierarchy = getLeftNavGroupFoldersStore().folderTable.get(groupId)?.folderHierarchy;
    if (folderHierarchy) {
        if (folderId) {
            const folderIds = folderHierarchy.get(folderId)?.ChildFolderIds;
            return folderIds;
        } else {
            let folderIds: string[] = [];
            /* Child Folders for the group to be displayed in below order
                Inbox
                Deleted Items
                User created parallel folders */
            folderIds.push(getGroupFolderId(groupId, GroupFolderWellKnownName.INBOX));
            folderIds.push(getGroupFolderId(groupId, GroupFolderWellKnownName.DELETEDITEMS));
            // TODO : Add parallel folders to the list as well when supported.
            return folderIds;
        }
    }
    return [];
}
